import type { ViewStyle } from "react-native";

import {
  type TypographyDecorations,
  type TypographyTypes,
  type TypographyVariants,
  palette,
} from "@stepapp/ui";

import type { HourItemTypes } from "../HourItem";

export const hourItemContainerStyle: { [key in HourItemTypes]: ViewStyle } = {
  available: {
    backgroundColor: palette.common.lightGray,
  },
  unavailable: {
    backgroundColor: palette.common.grayBackground,
  },
  selected: {
    backgroundColor: palette.primary.accent,
  },
  possible: {
    backgroundColor: palette.common.grayBackground,
  },
} as const;

export const hourItemTypographyVariantMapping: {
  [key in HourItemTypes]: TypographyVariants;
} = {
  available: "body",
  selected: "bodyBold",
  unavailable: "body",
  possible: "body",
} as const;

export const hourItemTypographyTypeMapping: {
  [key in HourItemTypes]: TypographyTypes;
} = {
  available: "primary",
  selected: "white",
  unavailable: "disabled",
  possible: "disabled",
} as const;

export const hourItemTypographyDecorationMapping: {
  [key in HourItemTypes]: TypographyDecorations;
} = {
  available: "none",
  selected: "none",
  unavailable: "lineThrough",
  possible: "none",
} as const;
